"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteTransactionRelation = exports.postTransactionRelation = exports.putTransactionOrganization = exports.putTransactionAccessibility = exports.deleteTransactionPermission = exports.postTransactionPermission = exports.delTransaction = exports.postTransaction = exports.putTransaction = exports.getTransaction = exports.getTransactions = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var path = root_1.accountingAuthorized + '/transactions/';

var getTransactions = function getTransactions(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getTransactions = getTransactions;

var getTransaction = function getTransaction(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getTransaction = getTransaction;

var putTransaction = function putTransaction(authentication, transaction) {
  return common_1.put(authentication, path + transaction.id, transaction);
};

exports.putTransaction = putTransaction;

var postTransaction = function postTransaction(authentication, transaction) {
  return common_1.post(authentication, path, transaction);
};

exports.postTransaction = postTransaction;

var delTransaction = function delTransaction(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delTransaction = delTransaction;

var postTransactionPermission = function postTransactionPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, path, id, permission);
};

exports.postTransactionPermission = postTransactionPermission;

var deleteTransactionPermission = function deleteTransactionPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, path, id, permissionId);
};

exports.deleteTransactionPermission = deleteTransactionPermission;

var putTransactionAccessibility = function putTransactionAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, path, id, accessibility);
};

exports.putTransactionAccessibility = putTransactionAccessibility;

var putTransactionOrganization = function putTransactionOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, path, id, organizationId);
};

exports.putTransactionOrganization = putTransactionOrganization;

var postTransactionRelation = function postTransactionRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postTransactionRelation = postTransactionRelation;

var deleteTransactionRelation = function deleteTransactionRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deleteTransactionRelation = deleteTransactionRelation;